import { motion } from "framer-motion";
import { FaReact, FaHtml5, FaCss3Alt, FaJs, FaCamera, FaGamepad, FaPlane, FaFilm } from "react-icons/fa";

export default function About() {
  return (
    <section
      id="about"
      className="relative py-28 bg-gradient-to-tr from-blue-50 to-purple-50 dark:from-gray-900 dark:to-indigo-900 overflow-hidden"
    >
      {/* Floating icons */}
      <motion.div
        className="absolute top-10 left-10 text-blue-200 text-5xl opacity-20"
        animate={{ y: [0, 20, 0] }}
        transition={{ duration: 6, repeat: Infinity }}
      >
        <FaReact />
      </motion.div>
      <motion.div
        className="absolute bottom-20 right-20 text-yellow-200 text-5xl opacity-20"
        animate={{ y: [0, -20, 0] }}
        transition={{ duration: 7, repeat: Infinity }}
      >
        <FaJs />
      </motion.div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-16 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
          About Me
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-start">

          {/* LEFT: Glass info card */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            className="bg-white/40 dark:bg-gray-800/30 backdrop-blur-md border border-white/30 dark:border-gray-700 rounded-3xl p-10 shadow-xl flex flex-col gap-6"
          >
            <h3 className="text-2xl font-bold text-gray-900 dark:text-blue-200">Ranjit Gautam</h3>
            <p className="text-lg text-gray-700 dark:text-gray-300 font-medium">Web Developer </p>
            <p className="text-gray-700 dark:text-gray-400">
              Domain: <a href="https://ranjitgautam.com.np" target="_blank" className="underline hover:text-blue-600">ranjitgautam.com.np</a>
            </p>
            <p className="text-gray-700 dark:text-gray-400">Education: BSC.CSIT</p>
            <p className="text-gray-700 dark:text-gray-400">Languages: Nepali, English, Hindi</p>
          </motion.div>

          {/* RIGHT: Skills & Interests in cards */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            className="grid grid-cols-1 gap-6"
          >
            {/* Skills */}
            <div className="bg-white/40 dark:bg-gray-800/30 backdrop-blur-md border border-white/30 dark:border-gray-700 rounded-3xl p-6 shadow-xl">
              <h4 className="text-xl font-semibold text-gray-900 dark:text-blue-200 mb-4">Skills</h4>
              <div className="flex flex-wrap gap-3">
                <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm">HTML5</span>
                <span className="bg-yellow-400 text-white px-3 py-1 rounded-full text-sm">CSS3</span>
                <span className="bg-yellow-500 text-white px-3 py-1 rounded-full text-sm">JavaScript</span>
                <span className="bg-blue-400 text-white px-3 py-1 rounded-full text-sm">React.js</span>
                <span className="bg-purple-500 text-white px-3 py-1 rounded-full text-sm">Git/Github</span>
              </div>
            </div>

            {/* Interests */}
            <div className="bg-white/40 dark:bg-gray-800/30 backdrop-blur-md border border-white/30 dark:border-gray-700 rounded-3xl p-6 shadow-xl">
              <h4 className="text-xl font-semibold text-gray-900 dark:text-blue-200 mb-4">Interests</h4>
              <div className="flex flex-wrap gap-4 text-gray-800 dark:text-gray-300">
                <div className="flex items-center gap-2"><FaPlane /> Traveling</div>
                <div className="flex items-center gap-2"><FaGamepad /> Playing Games</div>
                <div className="flex items-center gap-2"><FaFilm /> Watching Movies</div>
                <div className="flex items-center gap-2"><FaCamera /> Editing</div>
              </div>
            </div>

          </motion.div>
        </div>
      </div>
    </section>
  );
}
